<nb-card>
  <nb-card-header>
    <div class="form-inline">
      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          status="info"
          placeholder="{{ 'common.strSearch' | translate }}"
          [(ngModel)]="strSearch"
          #comment
        />
      </nb-form-field>

      <button
        nbButton
        hero
        shape="semi-round"
        status="info"
        size="small"
        (click)="receiveInventory()"
      >
        <nb-icon icon="arrow-circle-up-outline"></nb-icon>
        Nhập
      </button>

      <button
        nbButton
        hero
        shape="semi-round"
        status="warning"
        size="small"
        (click)="issueInventory()"
      >
        <nb-icon icon="arrow-circle-down-outline"></nb-icon>
        Xuất
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{ "common.date" | translate }}</th>
            <th scope="col">Diễn giải</th>
            <th scope="col" class="col-number">SL Nhập</th>
            <th scope="col" class="col-number">$ Nhập</th>
            <th scope="col" class="col-number">SL Xuất</th>
            <th scope="col" class="col-number">$ Xuất</th>
            <th scope="col" class="col-number">SL Tồn</th>
            <th scope="col" class="col-number">$ Tồn</th>
            <th scope="col" class="col-action"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of inventories | filter: strSearch; let i = index"
          >
            <td class="col-no">
              <button
                nbButton
                ghost
                status="danger"
                size="small"
                (click)="remove(item)"
              >
                <nb-icon icon="close-circle-outline"></nb-icon>
                {{ i + 1 }}
              </button>
            </td>
            <td>
              {{ item.issueDate | date: "dd/MM/yyyy" }}
            </td>
            <td>
              <label class="description">{{ item.comment }}</label>
            </td>
            <td class="col-number">
              {{ item.receiveQuantity | number }}
            </td>
            <td class="col-number">
              {{ item.receiveAmount | number }}
            </td>
            <td class="col-number">
              {{ item.issueQuantity | number }}
            </td>
            <td class="col-number">
              {{ item.issueAmount | number }}
            </td>
            <td class="col-number">
              <strong> {{ item.balanceQuantity | number }} </strong>
            </td>
            <td class="col-number">
              <strong> {{ item.balanceAmount | number }} </strong>
            </td>

            <td class="col-action">
              <button
                nbButton
                ghost
                shape="round"
                status="primary"
                size="small"
                (click)="onEdit(item)"
              >
                <nb-icon icon="edit-2-outline"></nb-icon>
              </button>
            </td>
          </tr>
        </tbody>

        <!-- <tfoot>
          <tr>
            <td class="col-label" colspan="3">
              <strong class="text-hint">TỔNG CỘNG</strong>
            </td>
            <td class="col-number">
              <strong class="text-info">
                {{ receiveAmount | number }}
              </strong>
            </td>
            <td class="col-number">
              <strong class="text-warning">
                {{ issueAmount | number }}
              </strong>
            </td>
            <td class="col-number">
              <strong class="text-primary">
                {{ balance | number }}
              </strong>
            </td>
            <td></td>
          </tr>
        </tfoot> -->
      </table>
    </div>
  </nb-card-body>
</nb-card>
